<script lang="tsx" setup>
import ExternalLink from "@/components/Links/ExternalLink.vue"
import TextLabel from "../Text/TextLabel.vue"

const props = defineProps<{
  links: { id: string; url: string }[]
}>()

const getTitleFromArchiveUrl = (url: string) => {
  const subdomain = url.split(".aaschool.ac.uk")[0].replace("https://pr", "")
  return subdomain ? subdomain.replace(/-/g, " ").replace(/_/g, " ") : ""
}

const filteredLinks = props.links.filter(
  link => link.url && !link.url.includes("https://pr2026.aaschool.ac.uk"),
)
</script>

<template>
  <div v-if="filteredLinks.length">
    <TextLabel>Archive:</TextLabel>
    <!-- <div>Archive links</div> -->
    <div v-for="link in filteredLinks" :key="link.id">
      <ExternalLink :href="link.url" :text="getTitleFromArchiveUrl(link.url)" />
    </div>
  </div>
</template>
